export const Logo = ({ className = "h-10 w-10", chip = false }) => (
  <img
    src="/logo-icon.png"
    alt="BMP Tech One logo"
    className={`${className} object-contain ${chip ? "rounded-lg bg-white p-1" : ""}`}
  />
);

export const Brand = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <Logo chip={light} />
    <span className="flex flex-col leading-none">
      <span className={`font-display font-extrabold text-[1.05rem] tracking-tight ${light ? "text-white" : "text-[#0A1F44]"}`}>
        BMP
      </span>
      <span className={`font-mono text-[0.6rem] uppercase tracking-[0.25em] mt-1 ${light ? "text-amber-300/90" : "text-blue-700/80"}`}>
        Your Recruitment Partner
      </span>
    </span>
  </span>
);
